import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { GetPaymentType } from "../../Services";

const AddEditPaymentType = ({
  editingPaymentType,
  setEditingPaymentType,
  setPaymentTypes,
  setShowModal,
}) => {
  const isEditing = Boolean(editingPaymentType);

  const [formData, setFormData] = useState({
    bank_name: "",
    account_name: "",
    account_number: "",
    account_address: "",
    is_active: true,
  });

  // ✅ Prefill form when editing
  useEffect(() => {
    if (editingPaymentType) {
      setFormData({
        bank_name: editingPaymentType.bank_name || "",
        account_name: editingPaymentType.account_name || "",
        account_number: editingPaymentType.account_number || "",
        account_address: editingPaymentType.account_address || "",
        is_active: editingPaymentType.is_active ?? true,
      });
    }
  }, [editingPaymentType]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let response;

      if (isEditing) {
        response = await GetPaymentType.updatePaymentType(editingPaymentType.id, formData);
        setPaymentTypes((prev) =>
          prev.map((p) => (p.id === editingPaymentType.id ? response : p))
        );
      } else {
        response = await GetPaymentType.createPaymentType(formData);
        setPaymentTypes((prev) => [response, ...prev]);
      }

      toast.success(`Payment Type ${isEditing ? "updated" : "added"} successfully!`);
      setEditingPaymentType(null);
      setShowModal(false);
    } catch (error) {
      console.error("Error saving payment type:", error);
      toast.error("Failed to save payment type. Please try again.");
    }
  };

  return (
    <div className="max-w-md mx-auto bg-white p-6 shadow-md rounded-xl">
      <form onSubmit={handleSubmit} className="space-y-3">
        {["bank_name", "account_name", "account_number", "account_address"].map((field) => (
          <div key={field} className="form-group">
            <label htmlFor={field} className="block text-sm font-medium mb-1 capitalize">
              {field.replace("_", " ")}
            </label>
            <input
              id={field}
              name={field}
              value={formData[field]}
              onChange={handleChange}
              placeholder={`Enter ${field.replace("_", " ")}`}
              className="form-control"
              required
            />
          </div>
        ))}

        <div className="form-group flex items-center gap-2">
          <input
            type="checkbox"
            id="is_active"
            name="is_active"
            checked={formData.is_active}
            onChange={handleChange}
          />
          <label htmlFor="is_active">Active</label>
        </div>

        <button type="submit" className="btn btn-primary w-full">
          {isEditing ? "Update Payment Type" : "Add Payment Type"}
        </button>
      </form>
    </div>
  );
};

export default AddEditPaymentType;
